var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_38510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 5.53125C6.41196 5.53125 7.53125 4.41196 7.53125 3.03125C7.53125 1.65054 6.41196 0.53125 5.03125 0.53125C3.65054 0.53125 2.53125 1.65054 2.53125 3.03125C2.53125 4.41196 3.65054 5.53125 5.03125 5.53125Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 7.03125C9.16136 7.03125 8.9375 7.25511 8.9375 7.53125V8.93753H7.53125C7.25511 8.93753 7.03125 9.16138 7.03125 9.43753V11.0625C7.03125 11.3387 7.25511 11.5625 7.53125 11.5625H8.9375V12.9688C8.9375 13.2449 9.16136 13.4688 9.4375 13.4688H11.0625C11.3386 13.4688 11.5625 13.2449 11.5625 12.9688V11.5625H12.9688C13.2449 11.5625 13.4688 11.3387 13.4688 11.0625V9.43753C13.4688 9.16138 13.2449 8.93753 12.9688 8.93753H11.5625V7.53125C11.5625 7.25511 11.3386 7.03125 11.0625 7.03125H9.4375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52835 12.5314H0.53125V11.9893C0.539211 11.2271 0.740227 10.4793 1.11552 9.81585C1.49082 9.15239 2.02815 8.59488 2.67732 8.19539C3.3265 7.7959 4.06634 7.56746 4.82773 7.53141C5.10241 7.51841 5.37666 7.5306 5.64716 7.56729",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_38510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors);
export default __webpack_public_path__ + "static/media/doctors.00ee0197d07d7db0a2d6dcaaf00df308.svg";
export { ForwardRef as ReactComponent };